import React from "react";
import { FileText, Users } from "lucide-react";

const TermsOfService = () => {
  const ContactCard = ({
    title,
    name,
    position,
    email,
    phone,
  }: {
    title: string;
    name: string;
    position: string;
    email: string;
    phone: string;
  }) => (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6 font-serif-kr">
      <h4 className="text-lg font-semibold text-blue-800 mb-4 flex items-center">
        <Users className="w-5 h-5 mr-2" />
        {title}
      </h4>
      <div className="space-y-2 text-sm">
        <p>
          <span className="font-medium text-gray-700">성명:</span> {name}
        </p>
        <p>
          <span className="font-medium text-gray-700">직위:</span> {position}
        </p>
        <p>
          <span className="font-medium text-gray-700">이메일:</span>
          <a
            href={`mailto:${email}`}
            className="text-blue-600 hover:text-blue-800 ml-2"
          >
            {email}
          </a>
        </p>
        <p>
          <span className="font-medium text-gray-700">전화:</span>
          <a
            href={`tel:${phone}`}
            className="text-blue-600 hover:text-blue-800 ml-2"
          >
            {phone}
          </a>
        </p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-xl p-6 mb-8">
          <div className="flex items-start">
            <FileText className="w-6 h-6 text-green-600 mr-3 mt-1 flex-shrink-0" />
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Aivy 서비스 이용약관
              </h2>
              <p className="text-sm text-gray-600 mb-2">
                <strong>시행일: 2025년 6월 1일</strong>
              </p>
              <p className="text-sm text-gray-600 mb-2">
                <strong>제정일: 2025년 6월 1일</strong>
              </p>
              <p className="text-gray-700 leading-relaxed">
                ㈜디에이블이 운영하는 Aivy 플랫폼 서비스의 이용조건, 절차,
                권리·의무 및 책임사항을 규정합니다.
              </p>
            </div>
          </div>
        </div>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">제1장 총칙</h2>
          <h3 className="text-lg font-bold text-gray-900 mb-4">제1조 (목적)</h3>
          <div>
            <p className="text-gray-700 mb-4">
              본 약관은 ㈜디에이블(이하 "회사")이 운영하는{" "}
              <strong>Aivy 플랫폼</strong>(AivyStudio·AI
              체험·교육·엔터테인먼트·케어 솔루션 등 총칭, 이하 "서비스")의
              이용조건, 절차, 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제2조 (용어 정의)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. "플랫폼" = 웹·앱·API 등 회사가 제공하는 Aivy 전반
            </p>
            <p className="text-gray-700 mb-2">
              2. "회원" = 본 약관에 동의하고 서비스를 이용하는 개인·법인
            </p>
            <p className="text-gray-700 mb-2">
              3. "에이전트(Agent)" = 회원 혹은 귀사가 Aivy에서 생성·배포하는 AI
              모델·앱·챗봇 등
            </p>
            <p className="text-gray-700 mb-2">
              4. "콘텐츠" = 회원이 업로드·생성·게시·저장하는 모든 데이터
            </p>
            <p className="text-gray-700 mb-2">
              5. "AI 결과값" = 회원 데이터·프롬프트를 기반으로 에이전트가 산출한
              출력
            </p>
            <p className="text-gray-700 mb-4">
              6. "유료서비스" = 과금(구독·API·스토리지·마켓 판매 등)이 수반되는
              서비스
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제3조 (약관의 효력·변경)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 회사는 약관을 서비스 초기화면에 게시합니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 관련 법령 범위 내에서 개정할 수 있으며, 개정 시 7일 전(불리한
              변경 30일 전) 공지합니다.
            </p>
            <p className="text-gray-700 mb-4">
              3. 변경일까지 탈퇴 또는 거부 의사를 밝히지 않으면 동의한 것으로
              간주합니다.
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제2장 이용계약
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제4조 (회원가입 및 관리)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 이용계약은 회원이 약관 동의-가입 신청, 회사 승낙 시 체결됩니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 실명·정확한 정보를 제공해야 하며, 변경 시 즉시 수정해야 합니다.
            </p>
            <p className="text-gray-700 mb-2">
              3. 회사는 기술·업무상 지장이 있거나 허위정보 등이 확인되면 승낙을
              제한할 수 있습니다.
            </p>
            <p className="text-gray-700 mb-2">
              4. 이용신청자는 반드시 실명과 실제 정보를 사용해야 하며 한 회원은
              오직 1건의 이용신청을 할 수 있습니다.
            </p>
            <p className="text-gray-700 mb-2">
              5. 실명이나 실제 정보를 입력하지 않은 회원은 법적인 보호를 받을 수
              없으며, 서비스 이용이 불가합니다.
            </p>
            <p className="text-gray-700 mb-2">
              6. 회원은 회원가입 시 기재한 사항이 변경되었을 경우 온라인으로
              수정을 하거나 전자우편 기타 방법으로 회사에 그 변경사항을 알려야
              합니다.
            </p>
            <p className="text-gray-700 mb-4">
              7. 제4항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여
              회사는 책임지지 않습니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제3장 계약 당사자의 의무
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제6조 (회사의 의무)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 회사는 Aivy 플랫폼의 안정적 운영을 위해 시스템 유지·보수에
              최선을 다하며, 회원이 원활하게 AI 에이전트를 생성·활용할 수 있도록
              지원합니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 회원의 개인정보와 AI 학습 데이터를 안전하게 관리하기 위한
              기술적·관리적 보호조치를 시행하고, 개인정보처리방침을 투명하게
              운영합니다.
            </p>
            <p className="text-gray-700 mb-4">
              3. 회원의 문의사항이나 서비스 개선 제안을 적극 검토하여 합리적
              기간 내 처리하며, 즉시 처리가 어려운 경우 진행상황을 안내합니다.
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제7조 (회원의 의무)
          </h3>
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-3">
              1. 회원은 Aivy 서비스 이용 시 다음 행위를 금지합니다:
            </h4>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>타인의 계정 도용 또는 부정 사용</li>
              <li>AI 에이전트를 통한 불법 콘텐츠 생성·유포</li>
              <li>서비스 시스템에 과부하를 유발하는 비정상적 접속</li>
              <li>타 회원의 AI 모델이나 데이터를 무단 복제·유출</li>
              <li>악성코드 업로드 또는 서비스 보안 취약점 악용</li>
              <li>허위정보 유포나 명예훼손 등 타인의 권리 침해</li>
              <li>미성년자 유해 콘텐츠 생성 또는 배포</li>
              <li>서비스를 이용한 무단 영리활동 (회사 승인 제외)</li>
              <li>저작권 등 지식재산권 침해 콘텐츠 생성·배포</li>
            </ul>
            <p className="text-gray-700 mb-2 mt-4">
              2. 회원은 본인의 계정 보안을 책임지며, 비밀번호 유출이나 부정사용
              발견 시 즉시 회사에 신고해야 합니다.
            </p>
            <p className="text-gray-700 mb-4">
              3. 에이전트 생성 시 타인의 권리를 침해하지 않도록 주의하며, 생성된
              AI 결과물의 활용에 대한 책임은 회원이 부담합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제4장 서비스의 제공 및 이용
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제8조 (서비스 이용)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. Aivy 서비스는 24시간 제공을 원칙으로 하되, 시스템 점검이나
              업데이트 시 일시 중단될 수 있습니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 회원은 무료·유료 플랜에 따라 차등화된 기능을 이용할 수 있으며,
              구체적인 이용 범위는 서비스 내 안내에 따릅니다.
            </p>
            <p className="text-gray-700 mb-2">
              3. AI 에이전트 생성 및 API 호출 등에는 공정사용정책(FUP)이
              적용되며, 과도한 사용 시 제한될 수 있습니다.
            </p>
            <p className="text-gray-700 mb-4">
              4. 14세 미만 이용자는 법정대리인의 동의를 받아 서비스를 이용할 수
              있습니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            제9조 (유료서비스)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 유료서비스는 구독형·종량제·마켓플레이스 판매 등 다양한 방식으로
              제공됩니다.
            </p>
            <p className="text-gray-700 mb-2">2. 요금제별 상세 내용:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>제공 기능 및 사용 한도</li>
              <li>결제 방법 및 주기</li>
              <li>환불 정책</li>
              <li>서비스 변경·해지 절차</li>
            </ul>
            <p className="text-gray-700 mb-4 mt-2">
              3. 구독 서비스는 별도 해지 전까지 자동 갱신되며, 갱신 전 이메일로
              안내합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제10조 (서비스 제공의 변경·중단)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. 다음의 경우 서비스가 제한될 수 있습니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>정기 시스템 점검 (사전 공지)</li>
                <li>긴급 보안 업데이트</li>
                <li>천재지변이나 국가비상사태</li>
                <li>AI 모델 업그레이드 작업</li>
                <li>클라우드 서버 장애</li>
              </ul>
              <p className="text-gray-700 mb-2">
                2. 계획된 작업은 최소 24시간 전 공지하며, 긴급 상황은 사후
                안내합니다.
              </p>
              <p className="text-gray-700">
                3. 장기간 서비스 중단이 필요한 경우 30일 전 통지하고 적절한
                보상방안을 마련합니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제11조 (회원 탈퇴 및 자격 상실)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. 회원은 언제든 탈퇴할 수 있으며, 탈퇴 시:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>생성한 에이전트는 30일간 보관 후 삭제</li>
                <li>유료서비스 잔여기간에 대한 환불 처리 불가</li>
                <li>개인정보는 법령에 따라 일정기간 보관 후 파기</li>
              </ul>
              <p className="text-gray-700 mb-2">
                2. 다음의 경우 회원자격이 제한될 수 있습니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>약관 위반 행위의 반복</li>
                <li>타 회원에게 피해를 주는 행위</li>
                <li>서비스 운영을 방해하는 행위</li>
                <li>불법 콘텐츠 생성·유포</li>
              </ul>
              <p className="text-gray-700 mb-4">
                3. 제재 전 소명기회를 제공하며, 이의신청 절차를 운영합니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제5장 결제 및 환불
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제16조 (결제 방식)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">1. 지원 결제수단:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>신용카드·체크카드</li>
                <li>간편결제 (네이버페이, 카카오페이 등)</li>
                <li>계좌이체 (기업회원)</li>
              </ul>
              <p className="text-gray-700 mb-4">
                2. 결제 실패 시 서비스가 일시정지됩니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제17조 (청약철회 및 환불)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. 유료서비스 구매 후 7일 이내, 미사용 시 전액 환불이
                가능합니다.
              </p>
              <p className="text-gray-700 mb-2">
                2. 다음의 경우 환불이 제한됩니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>크레딧 사용 후 계약 철회 결정을 알게 된 달에 대한 요금</li>
                <li>맞춤형 에이전트 제작 서비스 착수 후</li>
                <li>회원의 귀책사유로 인한 서비스 제한</li>
              </ul>
              <p className="text-gray-700 mb-4">
                3. (기업회원) AI 스튜디오의 경우, 기업 문의 후 내부 규정에 따라
                환불이 진행됩니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제18조 (과오납금 처리)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 시스템 오류나 중복결제 발생 시 3영업일 내 환불 처리합니다.
            </p>
            <p className="text-gray-700 mb-4">
              2. 환불은 원 결제수단으로 진행하며, 불가능한 경우 계좌이체로
              대체합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제6장 AI 윤리 및 데이터 보호
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제19조 (AI 윤리 원칙)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. Aivy는 다음 원칙을 준수합니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>인간 중심의 AI 개발</li>
                <li>편향과 차별 최소화</li>
                <li>투명성과 설명가능성 추구</li>
                <li>프라이버시 보호 우선</li>
              </ul>
              <p className="text-gray-700 mb-2">
                2. AI 에이전트는 유해 콘텐츠 생성을 거부하도록 설계됩니다.
              </p>
              <p className="text-gray-700 mb-4">
                3. 회원은 AI 윤리 가이드라인을 준수하여 에이전트를 활용해야
                합니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제20조 (데이터 처리 및 보호)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 회원이 입력한 데이터는 암호화되어 안전하게 저장됩니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. AI 모델 학습에 사용되는 데이터는 익명화 처리됩니다.
            </p>
            <p className="text-gray-700 mb-2">
              3. 회원은 언제든 본인 데이터의 삭제를 요청할 수 있습니다.
            </p>
            <p className="text-gray-700 mb-2">
              4. 제3자와의 데이터 공유는 회원 동의 하에만 이루어집니다.
            </p>
            <p className="text-gray-700 mb-4">
              5. (기업회원) AI 스튜디오에서 생성되고 분석되는 데이터는 사용자
              제공 외 어떠한 수단으로서도 사용되지 않습니다.
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제21조 (AI 생성물의 책임)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. AI가 생성한 콘텐츠의 정확성·적법성은 보장되지 않습니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 회원은 AI 생성물을 검토 후 사용해야 하며, 발생하는 문제에 대한
              책임을 부담합니다.
            </p>
            <p className="text-gray-700 mb-4">
              3. 저작권 침해가 의심되는 생성물은 즉시 삭제 조치됩니다.
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            제7장 지식재산권
          </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제22조 (저작권의 귀속)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. Aivy 플랫폼 및 기본 AI 모델의 지식재산권은 회사에 귀속됩니다.
              </p>
              <p className="text-gray-700 mb-2">
                2. 회원이 업로드한 원본 데이터의 권리는 회원이 보유합니다.
              </p>
              <p className="text-gray-700 mb-2">3. AI 생성물의 권리:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>회원의 창작적 기여가 있는 경우: 회원에게 귀속</li>
                <li>단순 생성의 경우: 저작권 미발생</li>
                <li>상업적 이용 시 별도 라이선스 확인 필요</li>
              </ul>
              <p className="text-gray-700 mb-4">
                4. 회사는 서비스 개선을 위해 익명화된 사용 패턴을 분석할 수
                있습니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">제8장 기타 </h2>
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제23조 (면책사항)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. 회사는 다음에 대해 책임지지 않습니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>무료서비스 이용 중 발생한 손해</li>
                <li>회원의 부주의로 인한 데이터 유실</li>
                <li>AI 생성물의 부정확성으로 인한 손실</li>
                <li>제3자 서비스 연동 중 발생한 문제</li>
              </ul>
              <p className="text-gray-700 mb-4">
                2. 단, 회사의 고의·중과실이 있는 경우는 예외로 합니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제24조 (손해배상)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 회사의 귀책사유로 회원에게 손해가 발생한 경우, 직접적이고
              현실적인 손해에 한해 배상합니다.
            </p>
            <p className="text-gray-700 mb-4">
              2. 회원이 약관을 위반하여 회사에 손해를 입힌 경우, 해당 손해를
              배상해야 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제25조 (분쟁해결)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 서비스 이용 관련 분쟁은 상호 협의를 통해 우선 해결합니다.
            </p>
            <p className="text-gray-700 mb-2">
              2. 협의가 이루어지지 않을 경우, 관련 법령에 따른 분쟁조정기관에
              조정을 신청할 수 있습니다.
            </p>
            <p className="text-gray-700 mb-4">
              3. 소송의 경우 회사 본점 소재지 관할법원을 제1심 법원으로 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제26조 (통지방법)
          </h3>
          <div className="space-y-6">
            <div>
              <p className="text-gray-700 mb-2">
                1. 회사는 다음 방법으로 회원에게 통지합니다:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-2">
                <li>회원 가입 시 등록한 이메일</li>
                <li>서비스 내 알림</li>
                <li>SMS (중요사항에 한함)</li>
              </ul>
              <p className="text-gray-700 mb-4">
                2. 전체 회원 대상 공지는 서비스 내 공지사항에 7일 이상 게시로
                갈음합니다.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            제27조 (약관의 효력)
          </h3>
          <div>
            <p className="text-gray-700 mb-2">
              1. 본 약관은 2025년 6월 1일부터 시행됩니다.
            </p>
            <p className="text-gray-700 mb-4">
              2. 구 약관에 따른 기존 권리·의무관계는 본 약관에 따라 승계됩니다.
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-xl font-bold text-gray-900 mb-6">[부칙]</h2>
          <div>
            <p className="text-gray-700 mb-2">- 제정일: 2025년 6월 1일</p>
            <p className="text-gray-700 mb-6">- 시행일: 2025년 6월 1일</p>
            <p className="text-gray-700">
              본 약관에 대한 문의사항은 고객센터(
              <a
                href="tel:07088053009"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                070-8805-3009
              </a>
              )로 연락 주시기 바랍니다.
            </p>
          </div>
        </section>

        <ContactCard
          title="개인정보 보호책임자"
          name="소지영"
          position="대표이사"
          email="dplanit@naver.com"
          phone="070-8805-3009"
        />
      </div>
    </div>
  );
};

export default TermsOfService;
